// FitClutch — funil web — textos em espanhol
export default {
  'ageSelect.titleLine1': 'Crea tu',
  'ageSelect.titleHighlight': 'Plan de Entrenamiento Personalizado',
  'ageSelect.poweredBy': 'Con inteligencia artificial de FitClutch',
  'ageSelect.subtitle': 'Elige tu rango de edad para empezar',
  'ageSelect.duration': 'Cuestionario de 3 minutos',
  'ageSelect.ageLabel': 'Edad: {range}',
  'ageSelect.footnote': 'Al continuar, aceptas nuestros {terms} y nuestra {privacy}.',
  'ageSelect.termsLink': 'Términos de Uso',
  'ageSelect.privacyLink': 'Política de Privacidad',

  'gender.title': '¿Cuál es tu género?',
  'gender.subtitle': 'Solo lo usamos para personalizar tu plan',
  'gender.male': 'Masculino',
  'gender.female': 'Femenino',
  'gender.other': 'Prefiero no decirlo',

  'socialProof.genderWomen': 'mujeres',
  'socialProof.genderMen': 'hombres',
  'socialProof.genderPeople': 'personas',
  'socialProof.decade20': 'en sus 20',
  'socialProof.decade30': 'en sus 30',
  'socialProof.decade40': 'en sus 40',
  'socialProof.decade50': 'en sus 50 o más',
  'socialProof.headlineBig': 'Más de {users} {gender}',
  'socialProof.subcopy': '{decade} ya confían en FitClutch para <hl>alcanzar sus objetivos, su nivel de condición física y el equipo que tienen disponible</hl>. Adaptándose a medida que evolucionas.',
  'socialProof.subcopyNoDecade': 'ya confían en FitClutch para <hl>alcanzar sus objetivos, su nivel de condición física y el equipo que tienen disponible</hl>. Adaptándose a medida que evolucionas.',
  'socialProof.downloadsLabel': 'Descargas',
  'socialProof.cta': 'Continuar',

  'goal.question': '¿Cuál es tu principal objetivo de fitness?',
  'goal.option_hipertrofia': 'Ganar músculo',
  'goal.option_emagrecer': 'Perder peso',
  'goal.option_forca': 'Ganar fuerza',
  'goal.option_condicionamento': 'Mejorar la condición física general',
  'goal.feedbackLead': 'Perfecto:',
  'goal.feedback_hipertrofia': 'sesiones de fuerza personalizadas con forma guiada en video en cada repetición.',
  'goal.feedback_emagrecer': 'un plan de entrenamiento pensado para mantener tu metabolismo activo.',
  'goal.feedback_forca': 'progresión de carga segura para ganar fuerza de verdad.',
  'goal.feedback_condicionamento': 'sesiones equilibradas para mejorar resistencia, movilidad y energía.',

  'bodyShape.question': '¿Cuál describe mejor tu cuerpo hoy?',
  'bodyShape.option_magro_male': 'Delgado',
  'bodyShape.option_magro_female': 'Delgada',
  'bodyShape.option_magro_neutral': 'Cuerpo delgado',
  'bodyShape.option_cheio_male': 'Más lleno',
  'bodyShape.option_cheio_female': 'Más llena',
  'bodyShape.option_cheio_neutral': 'Cuerpo más lleno',
  'bodyShape.option_atletico_male': 'Atlético',
  'bodyShape.option_atletico_female': 'Atlética',
  'bodyShape.option_atletico_neutral': 'Cuerpo atlético',
  'bodyShape.option_definido_male': 'Definido',
  'bodyShape.option_definido_female': 'Definida',
  'bodyShape.option_definido_neutral': 'Cuerpo definido',
  'bodyShape.option_medio_male': 'Medio',
  'bodyShape.option_medio_female': 'Media',
  'bodyShape.option_medio_neutral': 'Cuerpo medio',

  'bodyGoal.question': '¿Qué cuerpo quieres lograr?',
  'bodyGoal.option_definido_male': 'Definido y tonificado',
  'bodyGoal.option_definido_female': 'Definida y tonificada',
  'bodyGoal.option_definido_neutral': 'Cuerpo definido y tonificado',
  'bodyGoal.option_atletico_male': 'Atlético y musculoso',
  'bodyGoal.option_atletico_female': 'Atlética y en forma',
  'bodyGoal.option_atletico_neutral': 'Cuerpo atlético y musculoso',
  'bodyGoal.option_magro_male': 'Delgado y ligero',
  'bodyGoal.option_magro_female': 'Delgada y ligera',
  'bodyGoal.option_magro_neutral': 'Cuerpo delgado y ligero',
  'bodyGoal.option_curvilineo_male': 'Fuerte y robusto',
  'bodyGoal.option_curvilineo_female': 'Fuerte y con curvas',
  'bodyGoal.option_curvilineo_neutral': 'Cuerpo fuerte y definido',

  'lastBest.question': '¿Cuándo fue la última vez que te sentiste en tu mejor forma física?',
  'lastBest.option_agora': 'Ahora mismo',
  'lastBest.option_menos_1_ano': 'Hace menos de un año',
  'lastBest.option_1_3_anos': 'Hace 1-3 años',
  'lastBest.option_mais_3_anos': 'Hace más de 3 años',
  'lastBest.option_nunca': 'Nunca',

  'weightTrend.question': '¿Cómo suele variar tu peso?',
  'weightTrend.option_estavel': 'Bastante estable',
  'weightTrend.option_varia': 'Sube y baja según mis hábitos',
  'weightTrend.option_subindo': 'Ha ido subiendo poco a poco',
  'weightTrend.option_caindo': 'Ha ido bajando poco a poco',
  'weightTrend.option_nao_sei': 'No estoy seguro/a',

  'transformPromo.headline': 'Tu objetivo: {target}. Te mostraremos exactamente cómo lograrlo.',
  'transformPromo.subcopyLead': 'Entrena sin miedo a lesionarte. FitClutch tiene',
  'transformPromo.subcopyHighlight1': 'videos demostrativos',
  'transformPromo.subcopyMid': 'para cada ejercicio, ayudándote a hacer la forma correcta y',
  'transformPromo.subcopyHighlight2': 'evitar lesiones',
  'transformPromo.cta': 'Continuar',

  'pushUps.question': '¿Cuál es tu máximo de flexiones seguidas?',
  'pushUps.option_nenhuma': 'Ninguna todavía',
  'pushUps.option_1_5': '1 a 5',
  'pushUps.option_6_15': '6 a 15',
  'pushUps.option_16_30': '16 a 30',
  'pushUps.option_30_mais': 'Más de 30',

  'squats.question': '¿Cuántas sentadillas seguidas aguantas hacer?',
  'squats.option_nenhuma': 'Ninguna todavía',
  'squats.option_1_10': '1 a 10',
  'squats.option_11_25': '11 a 25',
  'squats.option_26_50': '26 a 50',
  'squats.option_50_mais': 'Más de 50',

  'flexibility.question': '¿Qué tan flexible eres?',
  'flexibility.option_nao_alcanco': 'No llego a tocar mis pies',
  'flexibility.option_quase': 'Casi llego a tocar mis pies',
  'flexibility.option_facil': 'Toco mis pies sin esfuerzo',
  'flexibility.option_muito_flexivel': 'Muy flexible (split, estiramientos profundos)',
  'flexibility.option_nao_sei': 'No lo sé',

  'progressPromo.headline': 'Tu punto de partida está definido. Ahora vamos a verlo moverse.',
  'progressPromo.subcopyLead': 'Cada entrenamiento se',
  'progressPromo.subcopyHighlight': 'registra automáticamente',
  'progressPromo.subcopyTail': '— estadísticas en tiempo real para mantenerte motivado.',
  'progressPromo.cta': 'Continuar',

  'focusArea.question': '¿Cuáles son tus zonas objetivo?',
  'focusArea.subtitle': 'Elige una zona específica o "Cuerpo completo".',
  'focusArea.option_superior': 'Parte superior',
  'focusArea.option_core': 'Core / Abdomen',
  'focusArea.option_inferior': 'Parte inferior',
  'focusArea.option_corpo_inteiro': 'Cuerpo completo',
  'focusArea.cta': 'Continuar',

  'injuries.question': '¿Alguna zona necesita más cuidado?',
  'injuries.subtitle': 'Adaptaremos tus ejercicios para proteger esas zonas.',
  'injuries.option_ombros': 'Hombros',
  'injuries.option_joelhos': 'Rodillas',
  'injuries.option_costas': 'Espalda',
  'injuries.option_nenhuma': 'Ninguna',
  'injuries.disclaimer': 'Ajustes preventivos — no sustituyen una evaluación médica.',
  'injuries.cta': 'Continuar',

  'workoutDuration.question': '¿Cuál es tu tiempo ideal de entrenamiento?',
  'workoutDuration.option_rapido': 'Rápido',
  'workoutDuration.option_rapido_subtitle': '3 ejercicios',
  'workoutDuration.option_rapido_badge': 'Hasta 20 min',
  'workoutDuration.option_curto': 'Corto',
  'workoutDuration.option_curto_subtitle': '4-6 ejercicios',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Medio',
  'workoutDuration.option_medio_subtitle': '5-7 ejercicios',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Largo',
  'workoutDuration.option_longo_subtitle': '8-10 ejercicios',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, sesiones de {duration} — ya están en camino.',
  'trainingSummaryPromo.subcopyLead': 'Directo de nuestra',
  'trainingSummaryPromo.subcopyHighlight': 'biblioteca de entrenamientos',
  'trainingSummaryPromo.subcopyTail': ', siempre hay uno listo para ti.',
  'trainingSummaryPromo.cta': 'Continuar',
  'trainingSummaryPromo.days_2': '1-2x por semana',
  'trainingSummaryPromo.days_4': '3-4x por semana',
  'trainingSummaryPromo.days_6': '5-6x por semana',
  'trainingSummaryPromo.days_7': 'Todos los días',

  'workSchedule.question': '¿Cómo es tu horario de trabajo?',
  'workSchedule.option_fixo': 'Horario de oficina',
  'workSchedule.option_noturno': 'Turno nocturno',
  'workSchedule.option_flexivel': 'Horario flexible',
  'workSchedule.option_parado': 'No estoy trabajando',

  'dailyActivity.question': '¿Qué tan activo es tu día a día?',
  'dailyActivity.option_sentado': 'Principalmente sentado',
  'dailyActivity.option_ativo': 'De pie o en movimiento',
  'dailyActivity.option_misto': 'Un poco de ambos',
  'dailyActivity.option_nao_sei': 'No estoy seguro',

  'sleepHours.question': '¿Cuántas horas sueles dormir?',
  'sleepHours.option_menos_5': 'Menos de 5 horas',
  'sleepHours.option_5_6': '5-6 horas',
  'sleepHours.option_7_8': '7-8 horas',
  'sleepHours.option_mais_8': 'Más de 8 horas',

  'waterIntake.question': '¿Cuántos vasos de agua bebes al día?',
  'waterIntake.subtitle': 'Toca el número más cercano a tu rutina.',
  'waterIntake.cta': 'Continuar',

  'profileSummary.headline': 'Aquí está tu perfil',
  'profileSummary.imcLabel': 'IMC - {imc}',
  'profileSummary.imcAbaixo': 'Bajo',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Alto',
  'profileSummary.imcObeso': 'Obeso',
  'profileSummary.bodyTypeLabel': 'Tipo de cuerpo',
  'profileSummary.bodyType_ectomorfo': 'Ectomorfo',
  'profileSummary.bodyType_mesomorfo': 'Mesomorfo',
  'profileSummary.bodyType_endomorfo': 'Endomorfo',
  'profileSummary.lifestyleLabel': 'Estilo de vida',
  'profileSummary.lifestyle_sedentario': 'Sedentario',
  'profileSummary.lifestyle_ativo': 'Activo',
  'profileSummary.lifestyle_equilibrado': 'Equilibrado',
  'profileSummary.conditioningLabel': 'Nivel de condición física',
  'profileSummary.conditioning_iniciante': 'Básico',
  'profileSummary.conditioning_intermediario': 'Intermedio',
  'profileSummary.conditioning_avancado': 'Avanzado',
  'profileSummary.conditioning_especialista': 'Experto',
  'profileSummary.metabolismLabel': 'Metabolismo',
  'profileSummary.metabolism_lento': 'Lento, gana peso fácilmente',
  'profileSummary.metabolism_acelerado': 'Acelerado, pierde peso fácilmente',
  'profileSummary.metabolism_equilibrado': 'Equilibrado',
  'profileSummary.metabolism_variavel': 'Variable, depende de los hábitos',
  'profileSummary.cta': 'Continuar',

  'barriers.question': '¿Qué te impidió ponerte en forma antes?',
  'barriers.option_motivacao': 'Falta de motivación',
  'barriers.option_sem_plano': 'Sin un plan estructurado',
  'barriers.option_tempo': 'Falta de tiempo',
  'barriers.option_lesoes': 'Lesiones físicas',
  'barriers.option_outro': 'Otros motivos',

  'consistencyChart.headline': '¡FitClutch te ayuda a mantener la constancia!',
  'consistencyChart.subcopyLead': 'Tu plan personalizado tiene todo lo que necesitas para',
  'consistencyChart.subcopyHighlight1': 'mantener la motivación alta',
  'consistencyChart.subcopyMid': 'y',
  'consistencyChart.subcopyHighlight2': 'alcanzar el cuerpo que quieres',
  'consistencyChart.chartTitle': 'Tu evolución',
  'consistencyChart.nowLabel': 'Ahora',
  'consistencyChart.withLabel': 'Con FitClutch',
  'consistencyChart.withoutLabel': 'Sin FitClutch',
  'consistencyChart.disclaimer': 'Aviso: los ejemplos son ilustrativos. Mantener la constancia en los entrenamientos y la alimentación es lo que realmente da resultado.',
  'consistencyChart.cta': 'Continuar',

  'progressLoader.headline': 'Creando tu Plan de Entrenamiento Personal',
  'progressLoader.item_bodyType': 'Adaptando a tu tipo de cuerpo y rutina',
  'progressLoader.item_fitnessLevel': 'Evaluando tu nivel de condición física',
  'progressLoader.item_plan': 'Armando tu plan personalizado',
  'progressLoader.testimonial1_title': 'Cambió mi rutina',
  'progressLoader.testimonial1_body': 'Por fin un plan que encaja de verdad en mi semana. Fácil de seguir y los entrenamientos tienen sentido.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Resultados reales',
  'progressLoader.testimonial2_body': 'En pocas semanas ya sentí la diferencia en energía y fuerza. El plan se ajusta a mí, no al revés.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'Una rutina que sí mantengo',
  'progressLoader.testimonial3_body': 'Nunca había logrado mantener una rutina hasta usar FitClutch. Ahora es parte de mi día.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Vale totalmente la pena',
  'progressLoader.testimonial4_body': 'Simple, directo y pensado de verdad para mi cuerpo y mi rutina.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Ingresa tu correo para recibir tu',
  'emailCapture.headlineHighlight': 'Plan de Entrenamiento Personalizado',
  'emailCapture.placeholder': 'tucorreo@ejemplo.com',
  'emailCapture.cta': 'Continuar',
  'emailCapture.privacyLead': 'Respetamos tu privacidad y protegemos tus datos personales, de acuerdo con nuestra',
  'emailCapture.privacyLink': 'Política de Privacidad',
};
